"use client";

import { authDebugLog } from "@/lib/authDebugLog";
import { cookieLog } from "@/lib/cookieDebugLog";
import { useRouter } from "next/navigation";
import { useEffect, useRef } from "react";

/**
 * Re-runs the root layout so server session state stays fresh in the header.
 */
export function RefreshSessionOnFocus() {
  const router = useRouter();
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    const schedule = () => {
      if (timeoutRef.current !== undefined) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = undefined;
        cookieLog("RefreshSessionOnFocus", "in", {
          reason: "focus_or_visibility",
          action: "router.refresh",
        });
        authDebugLog("RefreshSessionOnFocus → router.refresh() (focus or visibility)");
        router.refresh();
      }, 250);
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") schedule();
    };

    window.addEventListener("focus", schedule);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      if (timeoutRef.current !== undefined) clearTimeout(timeoutRef.current);
      window.removeEventListener("focus", schedule);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [router]);

  return null;
}
